import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, handleUserLevelAccessPermissions, getAllYears, validateRolesRowWool, validateMonthYears,shortMonthToMonthNumber } from '../../../../Custom/Custom'
import messages from '../.././../../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
// import WholeSaleRawWoolData from '../../../../Components/WholeSaleRawWoolData';
import WholeSalePriceData from "../../../../Components/WholeSalePriceData";
import "react-datepicker/dist/react-datepicker.css";
import othersData from '../../../../others.json'; 



const WholeSaleRawWool = () => {

  const [districtList, setDistrictList] = useState([]);
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const [districtCode, setDistrictCode] = useState('');
  const [yearName, setYearName] = useState('');
  const [monthName, setMonthName] = useState('');
 
  const [wholeSaleRawWoolForm, setWholeSaleRawWoolForm] = useState([]);
  const [payload, setPayload] = useState([]);
  const [isDivision, setIsDivision] = useState(false);
  const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const config = getAuthHeaders();

  let districtAndDivision=false;
 

  useEffect(() => {

    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)

    // get District By Division ID
    const getDistrictListByDivision = async () => {
      try {
        const response = await axios.post(
          `${API_URL}api/geDistrictListByDivisionId`,
          { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config);
        const allDistrict = response.data;
       if (allDistrict.status) {
           let dist=   allDistrict.data.filter((item,index)=>(["28", "36", "45", "64", "68"].includes(item.DISTRICT_CODE)))
           setDistrictList(dist);
           showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    }



    // All district list
    const getDistrictList = async () => {

      try {
        const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
        const allDistrict = response.data;

        if (allDistrict.status) {

         const allowDistrict = ["28", "36", "45", "64", "68"];
         const filteredDistricts = allDistrict.data.filter(district => allowDistrict.includes(district.DISTRICT_CODE));
         setDistrictList(filteredDistricts);
          
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };

    //Get all Months data    
    const getMonthsList = (e) => {
      showLoading(true)
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false)
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    }


    const getYearList = () => {
      setYears(getAllYears());
    }

    const pageLoadSixtySevenNecessaryItems = () => {
      showLoading(true);
      axios
        .get(`${API_URL}api/otherPrices/SixtySevenNecessaryItemsForm`, config)
        .then((res) => {
        
          const {data,success} = res.data;
          if (success) {
            //setSixtySevenNecessaryItems(data);
            setTimeout(() => (showLoading(false)), 3000)
          }
        }).catch((err) => {
          console.log(err)
          showLoading(false);
        });
    }

    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateRolesRowWool(decode_token)
        if (role) {

          pageLoadSixtySevenNecessaryItems();
          // SixtySevenNecessaryItemsInputFormDataUnitList();
          getYearList();
          getMonthsList();

          if (level.userLevel === 'DIVISION LEVEL' && level.roles.includes('DIVADM')) {
            getDistrictListByDivision()
            setIsDivision(true)
          } else {
            getDistrictList()
          }

        } else {

          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }


    userRole();


  }, []);


  const ondistrictchangePopulateData = (districtId) => {
    showLoading(true);
    axios
      .post(
        `${API_URL}api/otherPrices/WholeSaleRawWoolForm`,
        {
          district_code: districtId,
        },
        config
      )
      .then((response) => {
        const { data, status } = response.data;
        if (status) {
          if (data[0].GroupCodes.length === 0) {
            toast.error(response.data.message, messages.COLOR_RED);
          }
          setWholeSaleRawWoolForm(data[0].GroupCodes);
        }
        setTimeout(() => showLoading(false), 3000);
      })
      .catch((error) => {
        console.error("Error fetching district data:", error);
        showLoading(false);
      });
  };


  const handleDropdownChange = (e) => {

    switch (e.target.name) {
      case 'district_name':
        setDistrictCode(e.target.value)
        ondistrictchangePopulateData(e.target.value);
        setMonthName('')
        setYearName('')
        break;
      case 'month_name':
        setMonthName(e.target.value)
        setYearName('')
        break;
      case 'year_name':

        if (!validateMonthYears(e.target.value, monthName)) {
          setMonthName('')
          setYearName('')
          return;
        }

        if (districtCode === '') {
          toast.error(messages.DISTRICT_MSG, messages.COLOR_RED);
          setYearName('')
          return;
        }

        if (monthName === '') {
          toast.error(messages.MONTH_MSG, messages.COLOR_RED);
          setYearName('')
          return;
        }
        setYearName(e.target.value)
        let postData = {
          "district_code": districtCode,
          "month_ws": shortMonthToMonthNumber(monthName),
          "year_ws": e.target.value
        }
        onChangeWholeSaleRawWoolPricePrice(postData)


        break;
      default:
        console.log("switch case are not match");
        break;

    }
  }

  const onChangeWholeSaleRawWoolPricePrice = async (postData) => {
    showLoading(true)

    try {

      const response = await axios.post(`${API_URL}api/otherPrices/WholeSaleRawWoolFormWithData`, postData, config);
      if (response.data.status) {
        setWholeSaleRawWoolForm(response.data.data[0].GroupCodes);
        setPayload(response.data.data[1].payload)
        showLoading(false)
      }

    } catch (error) {
      console.error('Error posting data:', error);
      showLoading(false)
    }

  }
  const resetMothAndYearField = () => {
    setMonthName('')
    setYearName('')
    setDistrictCode('')
    setWholeSaleRawWoolForm([]);
  }



  const storedLanguage = localStorage.getItem('language');

  const showMessagewhole = () =>{
    toast.error("Please select district, month, year", messages.COLOR_RED);
  }


  if( (buttonAccess.userLevel==='DISTRICT LEVEL' ||  buttonAccess.userLevel==='DIVISION LEVEL') ){
    districtAndDivision=true;
  }


  return (
    <>

      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? othersData.hi.Whole_Sale_Raw_Wool : othersData.en.Whole_Sale_Raw_Wool }} />
                </h4>
              <div className="row align-items-center">
                {isDivision &&
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                    <input typr="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
                }


                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                  <select
                    name="district_name"
                    id="district_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={districtCode}
                  >
                    <option value="" disabled>Select District</option>
                    {districtList &&
                      districtList
                        .slice()
                        .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                        .map((ele, index) => (
                          <option key={index} value={ele.DISTRICT_CODE}>
                            {ele.DISTRICT_NAME}
                          </option>
                        ))}
                  </select>
                </div>





                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                  <select name="month_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={monthName}
                  >
                    <option value="" disabled>Select Month</option>
                    {months && months.map((ele, i) => (
                      <option key={i} value={ele.MONTH}>
                        {shortMonthToFull(ele.MONTH)}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
                  <select name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName} >
                    <option value="" disabled>Select Year</option>
                    {years && years.map((ele, index) => (
                      <option key={index} value={ele}>
                        {ele}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card mx-3 mb-3">
          {wholeSaleRawWoolForm.length > 0 ? (
            <WholeSalePriceData
              type="wholeSaleRawWool"
              payload={payload}
              districtCode={districtCode}
              config={config}
              resetMothAndYearField={resetMothAndYearField}
              userInfoObject={buttonAccess}
              yearName={yearName}
              monthName={monthName}
              wholeSalePrice={wholeSaleRawWoolForm}
              url="/otherPrices/getwholeSaleRawWoolFormDataSaveToDB"
            />
          ) : (
           
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th rowSpan="2">Serial No.</th>
                        <th rowSpan="2">Item Name</th>
                        <th rowSpan="2">Variety Name</th>
                        <th rowSpan="2">Unit</th>
                        <th colSpan="5">Monthly Friday (Price(Rs.))</th>
                        <th rowSpan="2">Average</th>
                        <th rowSpan="2">Remarks</th>
                        <th rowSpan="2">REJECT STATUS</th>
                      </tr>
                      <tr>
                        <th>First Friday</th>
                        <th>Second Friday</th>
                        <th>Third Friday</th>
                        <th>Fourth Friday</th>
                        <th>Fifth Friday</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>
                          <input
                            type="text"
                            id="itemName0"
                            disabled
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            id="itemVarietyName0"
                            disabled
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            id="itemUnitName0"
                            disabled
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="firstFriday0"
                            id="firstFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="secondFriday0"
                            id="secondFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="thirdFriday0"
                            id="thirdFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="fourthFriday0"
                            id="fourthFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="fifthFriday0"
                            id="fifthFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="controlledPrice0"
                            id="controlledPrice0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td className="grid-row">
                          <select
                            name="remark0"
                            id="remark0"
                            className="form-select"
                            defaultValue=""
                          >
                            <option value="">[---Select---]</option>
                            <option value="Price is Too Low.">
                              Price is Too Low.
                            </option>
                            <option value="Price is too High.">
                              Price is too High.
                            </option>
                            <option value="Price does not match with unit.">
                              Price does not match with unit.
                            </option>
                            <option value="Price does not match with variety.">
                              Price does not match with variety.
                            </option>
                            <option value="Other.">Other.</option>
                          </select>
                        </td>
                        <td colSpan="1">
                          <input type="checkbox" name="status0" id="status0" 
                          disabled={districtAndDivision  ? 'disabled' : ''}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
             
                <div className="row">
                  <div className="col-12 text-center pt-3">
                    <button type="button" className="btn btn_orange mx-1" onClick={(e)=>(showMessagewhole())}>
                        Save
                    </button>

                    {(buttonAccess.userLevel==='DISTRICT LEVEL' || buttonAccess.userLevel==='DIVISION LEVEL') &&
                      <button type="button" className="btn btn_orange mx-1" onClick={(e)=>(showMessagewhole())}>
                      Submit
                    </button>
                    }

                        
                    {(buttonAccess.userLevel==='HEAD QUARTER') && 
                        <>
                      <button type="button" className="btn btn_orange mx-1" onClick={(e)=>(showMessagewhole())}>
                        Accept
                      </button>
                      <button type="button" className="btn btn_orange mx-1" onClick={(e)=>(showMessagewhole())}>
                        Reject
                      </button>
                        </>
                    }

                    <button type="reset" className="btn btn_orange mx-1">
                      Reset
                    </button>
                    <button 
                    type="button" 
                    className="btn btn_orange mx-1" 
                    onClick={(e)=>( navigate("/dashboard"))} 
                    >
                    Cancel
                  </button>
                  </div>
                </div>
            </div>
          )}
        </div>

      </div>

    </>
  )
}

export default WholeSaleRawWool